// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ae1cea44","132":"42dd091e","235":"87ce7230","309":"b57bef68","320":"54582e45","333":"2484d965","565":"b1e5ec7f","808":"50fbd93c","831":"80754487","843":"752a84a2","845":"4833d6f4","928":"bd014d60"}[chunkId] + ".chunk.js";
};